import { useOutletContext } from "react-router-dom";

import HomeProducerView from "../views/HomeProducerView";

export default function HomeProducer() {
	const { organization } = useOutletContext();

	return <HomeProducerView organization={organization} />;
}
